/**************************************************************************************************/
/*   File: /src/app/shared/components/expander/expander.component.ts                              */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday May 10th 2019                                                           */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri May 10 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Observable } from 'rxjs';

import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

/**
 * The loader
 */
@Component({
    selector: 'nwpl-frnt-expander',
    templateUrl: './expander.component.html',
    styleUrls: ['./expander.component.scss']
})
export class ExpanderComponent implements OnInit {

    /**
     * The is loading boolean
     * @type {boolean}
     */
    @Input() isExpanded: boolean;
    /**
     * The event emitter
     * @type {EventEmitter<boolean>}
     */
    @Output() expanded: EventEmitter<boolean> = new EventEmitter<boolean>();

    /**
     * The constructor
     */
    constructor() {
        this.isExpanded = false;
    }

    /**
     * The ng on init hook
     */
    ngOnInit() {

    }

    /**
     * Toggle expanded variable and emit value to top
     * @param $event The event
     */
    toggleExpanded($event: Event) {
        this.isExpanded = !this.isExpanded;
        this.expanded.emit(this.isExpanded);
    }

}